/**
 * @generated SignedSource<<684419b7ee42e6b7d5c96f8a04c99b11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useEuEligible_viewer$data = {
  readonly isCountryInEu: boolean | null;
  readonly " $fragmentType": "useEuEligible_viewer";
};
export type useEuEligible_viewer$key = {
  readonly " $data"?: useEuEligible_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEuEligible_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useEuEligible_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "country",
          "variableName": "userCountryCode"
        }
      ],
      "kind": "ScalarField",
      "name": "isCountryInEu",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b23f15f8d1667ea7f9addec3ac1100f1";

export default node;
